import React from 'react';

import { Input } from '@chakra-ui/react';

export function TextField({ ...props }) {
  return <Input my="mg0" {...props} />;
}
